import React, {Component} from "react";
import PropTypes from "prop-types";
import {makeGetAggregatedData} from "../../selectors/aggregatedSelector";
import {compose} from "redux";
import {connect} from "react-redux";
import {isNil} from "lodash";
import withFiniteValues from "./withFiniteValues";
import {withTranslation} from "react-i18next";
import Fetcher from "./Fetcher";
import TimestampChecker from "./TimestampChecker";
import NewIOT from "../../IOT/NewIOT";
import memoizeOne from "memoize-one";
import {Milliseconds} from "../../constans/milliseconds";

const DEBUG = true;

// we want to prevent frequent mqtt requests by using a global cache and a threshold of 5 minutes
const getTiming = memoizeOne((moduleName, farmId, deviceType) => {
    DEBUG &&
        console.debug(
            "[AggFetcher] requestMQTTAggData reinit cache for %s of %s",
            deviceType,
            farmId
        );
    const cache = {};
    const minTimeBeforeRequestingFreshData = 5 * Milliseconds.MINUTE;
    return {
        markAsDated: (key) => (cache[key] = Date.now()),
        isOutdated: (key) =>
            Date.now() - (cache[key] ?? 0) > minTimeBeforeRequestingFreshData,
    };
});

/*
 prosze uzywac key device_index - bez podmieniania dynamicznie device i index bo sie zepsuje!
 */
class AggFetcher extends Component {
    constructor(props) {
        super(props);
        this.tc = new TimestampChecker();
    }

    requestMQTTAggData = () => {
        DEBUG && console.debug("[AggFetcher] requestMQTTAggData called");
        const {device, dataType} = this.props;
        if (device && device.GatewayID) {
            const [moduleName, farmId, deviceType] = window.location.pathname
                .substring(1)
                .split("/");
            const timing = getTiming(moduleName, farmId, deviceType);
            const key = device?.DevID + "#" + dataType;
            if (timing.isOutdated(key)) {
                timing.markAsDated(key);
                DEBUG &&
                    console.debug(
                        "[AggFetcher] sendRequestForAggregatedData [OK]"
                    );
                NewIOT.sendRequestForAggregatedData(device, {dataType});
            } else {
                DEBUG &&
                    console.debug(
                        "[AggFetcher] sendRequestForAggregatedData [SKIP]"
                    );
            }
        }
    };

    componentDidMount() {
        this.requestMQTTAggData();
    }

    render() {
        const {device, index, start, end, isDuration, id, dataType} =
            this.props;
        const uniqueKey = `${device.DevID}_${index}_${start}_${end}_${!!isDuration}_${id}_${dataType ?? "general"}`;
        return <Fetcher {...this.props} tc={this.tc} key={uniqueKey} />;
    }
}

AggFetcher.propTypes = {
    device: PropTypes.object.isRequired,
    index: PropTypes.number,
    key: PropTypes.string.isRequired, // `${device.DevID}_${index}`
    start: PropTypes.number.isRequired, //utc timestamp
    end: PropTypes.number, //utc timestamp
    isDuration: PropTypes.bool,
    currentDayRefreshTime: PropTypes.number,
    showNewestDate: PropTypes.bool,
    prefetchData: PropTypes.bool,
    prefetchDays: PropTypes.number,
    id: PropTypes.string,
};

AggFetcher.defaultProps = {
    currentDayRefreshTime: 0, // defaultowo wywalone,
    showNewestDate: false,
    prefetchData: true,
    prefetchDays: 5,
    dataType: null,
    id: "none",
};

function makeMapStateToProps() {
    const getAggregated = makeGetAggregatedData();
    const params = {};
    return function mapStateToProps(state, props) {
        params.DevID = props.device.DevID;
        if (!isNil(props.index)) {
            params.index = props.index;
        }
        if (!isNil(props.dataType)) {
            params.dataType = props.dataType;
        }
        return {
            aggregated: getAggregated(state, params),
        };
    };
}

export default compose(
    withFiniteValues,
    connect(makeMapStateToProps),
    withTranslation()
)(AggFetcher);
